import sdkUrl from "@/api/sdkurl";

//域名
const domain = "https://game.tian-xsy.com";
const webConfig =  {
    //应用名称
    appName: "真好玩",
    //应用名称
    gameAppName: "真好玩",
    //网页title
    webTitle: "真好玩",
    //应用图标
    logoUrl: require("@/assets/logo.png"),
    //圆形logo
    logoRoundUrl: require("@/assets/logo-round.png"),
    //微信公众号
    wechatUrl: require("@/assets/gzh.jpg"),
    //应用二维码
    appqrUrl: "",
    //icp备案
    icp: "鄂ICP备2024067208号-1",
    //公安备案
    publicSecurity: "",
    //版权所有
    copyright: "copyright © 2026 tian-xsy.com All Rights Resered.",
    //公司名称
    companyName: "宜昌天欣网络科技有限公司",
    //公司地址
    address: "宜昌市夷陵区东城试验区东城路19号",
    //公司名称
    copyrightCompany: "真好玩平台 版权所有",
    //app备案
    appRecord: "",
    //用户协议
    agreement :  domain + "/static/agreement/user.html",
    //隐私政策
    privacy :  domain + "/static/agreement/privacy.html",
    //QQ客服
    qqkfList: [
         //{"info": "1416991369", "worktime": ""}
    ],
    wxkfList: [
        //{"info": "https://work.weixin.qq.com/kfid/kfc365511be9209c54e", "worktime": "09:00-22:00"}
    ],
    telkfList: [
        // {"info": "", "worktime": ""}
    ],
    //平台币名称
    coinName: "星辰币",
    bindCoinName: '绑币',
    //游戏加速器地址
    speedUrl: domain + "/static/speed/a.html?genCode=true",
    //sdkweb地址
    sdkUrl: sdkUrl,
    //默认搜索游戏名
    defaultSearchName: "斗罗大陆",
    hotSearchName: ["斗罗大陆"],
    redirectUri: domain + "/#/rechargeWeiXin",
    appid: "wx4d86611b3f48c5e7",
    drawUrl: domain + '/welfare/',
    gameUrlMiddle: "/h5/",
}

export default webConfig